module.exports = __webpack_public_path__ + "static/media/logo.d10a2ca5.png";